import React, { useState } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import CardOptions from './components/CardOptions/CardOptions';
import { Input, Icon } from 'components';
import styles from './DropdownBuilder.scss';

const DropdownBuilder = ({
  addButtonText,
  defaultValue,
  isDisabled,
  onChange,
  placeholder,
  newOptionPlaceholder
}) => {
    const [value, setValue] = useState(defaultValue);

    const handleChange = (newList) => {
        setValue(newList);
        onChange(newList);
    };

    return (
        <React.Fragment>
            <Input
                className={styles.input}
                placeholder={placeholder}
                aria-label={placeholder}
                readOnly
                disabled
                endAdornment={
                    <Icon name='ion-md-arrow-dropdown' />
                }
            />
            <CardOptions
                addButtonText={addButtonText}
                isDisabled={isDisabled}
                onChange={handleChange}
                options={value}
                newOptionPlaceholder={newOptionPlaceholder}
            />
        </React.Fragment>
    );
};

DropdownBuilder.propTypes = {
    addButtonText: PropTypes.string.isRequired,
    newOptionPlaceholder: PropTypes.string,
    defaultValue: PropTypes.arrayOf(PropTypes.shape({
        display: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
    })),
    isDisabled: PropTypes.bool,
    onChange: PropTypes.func,
    placeholder: PropTypes.string.isRequired
};

DropdownBuilder.defaultProps = {
    defaultValue: [
        { value: uuid(), display: '' },
        { value: uuid(), display: '' },
        { value: uuid(), display: '' }
    ],
    isDisabled: false,
    onChange: () => {},
    placeholder: 'Choose...',
    newOptionPlaceholder: 'New Item',
    addButtonText: 'Add item'
};

export default DropdownBuilder;
